export const quotaionMockData = {
    Me_and_My_Direct_Family: {
        10000: [
            { minAge: 18, maxAge: 25, premium: 43.0 },
            { minAge: 26, maxAge: 35, premium: 47.5 },
            { minAge: 36, maxAge: 45, premium: 58.5 },
            { minAge: 46, maxAge: 55, premium: 85.0 },
            { minAge: 56, maxAge: 60, premium: 108.0 }
        ],
        20000: [
            { minAge: 18, maxAge: 25, premium: 54.0 },
            { minAge: 26, maxAge: 35, premium: 64.5 },
            { minAge: 36, maxAge: 45, premium: 87.0 },
            { minAge: 46, maxAge: 55, premium: 137.5 },
            { minAge: 56, maxAge: 60, premium: 183.5 }
        ],
        40000: [
            { minAge: 18, maxAge: 25, premium: 76.5 },
            { minAge: 26, maxAge: 35, premium: 97.0 },
            { minAge: 36, maxAge: 45, premium: 141.0 },
            { minAge: 46, maxAge: 55, premium: 242.5 },
            { minAge: 56, maxAge: 60, premium: 334.0 }
        ],
        50000: [
            { minAge: 18, maxAge: 25, premium: 87.5 },
            { minAge: 26, maxAge: 35, premium: 113.0 },
            { minAge: 36, maxAge: 45, premium: 169.0 },
            { minAge: 46, maxAge: 55, premium: 295.0 },
            { minAge: 56, maxAge: 60, premium: 405.5 }
        ],
        60000: [
            { minAge: 18, maxAge: 25, premium: 104.0 },
            { minAge: 26, maxAge: 35, premium: 145.5 },
            { minAge: 36, maxAge: 45, premium: 206.0 },
            { minAge: 46, maxAge: 55, premium: 348.5 },
            { minAge: 56, maxAge: 60, premium: 486.5 }
        ],
        80000: [
            { minAge: 18, maxAge: 25, premium: 128.5 },
            { minAge: 26, maxAge: 35, premium: 182.5 },
            { minAge: 36, maxAge: 45, premium: 263.5 },
            { minAge: 46, maxAge: 55, premium: 455.5 },
            { minAge: 56, maxAge: 60, premium: 636.5 }
        ]
    },
    Myself: {
        10000: [
            { minAge: 18, maxAge: 25, premium: 18.0 },
            { minAge: 26, maxAge: 35, premium: 27.5 },
            { minAge: 36, maxAge: 45, premium: 31.0 },
            { minAge: 46, maxAge: 55, premium: 40.0 },
            { minAge: 56, maxAge: 60, premium: 51.0 }
        ],
        20000: [
            { minAge: 18, maxAge: 25, premium: 22.5 },
            { minAge: 26, maxAge: 35, premium: 41.0 },
            { minAge: 36, maxAge: 45, premium: 48.0 },
            { minAge: 46, maxAge: 55, premium: 64.0 },
            { minAge: 56, maxAge: 60, premium: 86.5 }
        ],
        40000: [
            { minAge: 18, maxAge: 25, premium: 35.0 },
            { minAge: 26, maxAge: 35, premium: 76.5 },
            { minAge: 36, maxAge: 45, premium: 91.0 },
            { minAge: 46, maxAge: 55, premium: 113.0 },
            { minAge: 56, maxAge: 60, premium: 157.0 }
        ],
        50000: [
            { minAge: 18, maxAge: 25, premium: 40.0 },
            { minAge: 26, maxAge: 35, premium: 91.5 },
            { minAge: 36, maxAge: 45, premium: 110.0 },
            { minAge: 46, maxAge: 55, premium: 137.5 },
            { minAge: 56, maxAge: 60, premium: 192.0 }
        ],
        60000: [
            { minAge: 18, maxAge: 25, premium: 45.0 },
            { minAge: 26, maxAge: 35, premium: 106.5 },
            { minAge: 36, maxAge: 45, premium: 129.5 },
            { minAge: 46, maxAge: 55, premium: 161.5 },
            { minAge: 56, maxAge: 60, premium: 227.5 }
        ],
        80000: [
            { minAge: 18, maxAge: 25, premium: 55.5 },
            { minAge: 26, maxAge: 35, premium: 137.5 },
            { minAge: 36, maxAge: 45, premium: 166.5 },
            { minAge: 46, maxAge: 55, premium: 210.0 },
            { minAge: 56, maxAge: 60, premium: 296.5 }
        ]
    },
    My_Extended_Family: {
        5000: [
            { minAge: 0, maxAge: 25, premium: 6.5 },
            { minAge: 26, maxAge: 35, premium: 11.5 },
            { minAge: 36, maxAge: 45, premium: 15.5 },
            { minAge: 46, maxAge: 55, premium: 17.5 },
            { minAge: 56, maxAge: 65, premium: 29.0 },
            { minAge: 66, maxAge: 70, premium: 39.0 }
        ],
        10000: [
            { minAge: 0, maxAge: 25, premium: 9.5 },
            { minAge: 26, maxAge: 35, premium: 19.5 },
            { minAge: 36, maxAge: 45, premium: 27.5 },
            { minAge: 46, maxAge: 55, premium: 31.0 },
            { minAge: 56, maxAge: 65, premium: 53.5 },
            { minAge: 66, maxAge: 70, premium: 73.0 }
        ],
        15000: [
            { minAge: 0, maxAge: 25, premium: 13.0 },
            { minAge: 26, maxAge: 35, premium: 27.5 },
            { minAge: 36, maxAge: 45, premium: 39.5 },
            { minAge: 46, maxAge: 55, premium: 44.5 },
            { minAge: 56, maxAge: 65, premium: 77.5 },
            { minAge: 66, maxAge: 70, premium: 107.0 }
        ],
        20000: [
            { minAge: 0, maxAge: 25, premium: 16.0 },
            { minAge: 26, maxAge: 35, premium: 35.5 },
            { minAge: 36, maxAge: 45, premium: 51.0 },
            { minAge: 46, maxAge: 55, premium: 58.0 }
        ],
        30000: [
            { minAge: 0, maxAge: 25, premium: 22.0 },
            { minAge: 26, maxAge: 35, premium: 51.0 },
            { minAge: 36, maxAge: 45, premium: 74.5 },
            { minAge: 46, maxAge: 55, premium: 85.0 }
        ],
        40000: [
            { minAge: 0, maxAge: 25, premium: 28.0 },
            { minAge: 26, maxAge: 35, premium: 67.5 },
            { minAge: 36, maxAge: 45, premium: 98.5 },
            { minAge: 46, maxAge: 55, premium: 112.0 }
        ],
        50000: [
            { minAge: 0, maxAge: 25, premium: 34.5 },
            { minAge: 26, maxAge: 35, premium: 83.0 },
            { minAge: 36, maxAge: 45, premium: 122.5 },
            { minAge: 46, maxAge: 55, premium: 139.0 }
        ]
    },
    My_Parents_and_In_laws: {
        5000: [
            { minAge: 0, maxAge: 25, premium: 5.5 },
            { minAge: 26, maxAge: 35, premium: 7.0 },
            { minAge: 36, maxAge: 45, premium: 8.5 },
            { minAge: 46, maxAge: 55, premium: 15.0 },
            { minAge: 56, maxAge: 65, premium: 28.0 },
            { minAge: 66, maxAge: 70, premium: 39.0 }
        ],
        10000: [
            { minAge: 0, maxAge: 25, premium: 7.5 },
            { minAge: 26, maxAge: 35, premium: 10.0 },
            { minAge: 36, maxAge: 45, premium: 13.5 },
            { minAge: 46, maxAge: 55, premium: 25.5 },
            { minAge: 56, maxAge: 65, premium: 51.5 },
            { minAge: 66, maxAge: 70, premium: 73.0 }
        ],
        15000: [
            { minAge: 0, maxAge: 25, premium: 9.5 },
            { minAge: 26, maxAge: 35, premium: 13.5 },
            { minAge: 36, maxAge: 45, premium: 18.5 },
            { minAge: 46, maxAge: 55, premium: 36.0 },
            { minAge: 56, maxAge: 65, premium: 74.5 },
            { minAge: 66, maxAge: 70, premium: 107.0 }
        ],
        20000: [
            { minAge: 0, maxAge: 25, premium: 11.5 },
            { minAge: 26, maxAge: 35, premium: 16.5 },
            { minAge: 36, maxAge: 45, premium: 23.0 },
            { minAge: 46, maxAge: 55, premium: 47.0 }
        ],
        30000: [
            { minAge: 0, maxAge: 25, premium: 15.5 },
            { minAge: 26, maxAge: 35, premium: 23.5 },
            { minAge: 36, maxAge: 45, premium: 33.0 },
            { minAge: 46, maxAge: 55, premium: 68.0 }
        ],
        40000: [
            { minAge: 0, maxAge: 25, premium: 20.0 },
            { minAge: 26, maxAge: 35, premium: 30.0 },
            { minAge: 36, maxAge: 45, premium: 42.5 },
            { minAge: 46, maxAge: 55, premium: 89.5 }
        ],
        50000: [
            { minAge: 0, maxAge: 25, premium: 24.0 },
            { minAge: 26, maxAge: 35, premium: 36.5 },
            { minAge: 36, maxAge: 45, premium: 52.5 },
            { minAge: 46, maxAge: 55, premium: 110.5 }
        ]
    }
};
export const incomeStabilizationMock = {
    Me_and_My_Direct_Family: {
        1000: {
            10000: [
                { minAge: 18, maxAge: 25, premium: 47.0 },
                { minAge: 26, maxAge: 35, premium: 54.0 },
                { minAge: 36, maxAge: 45, premium: 68.5 },
                { minAge: 46, maxAge: 55, premium: 101.5 },
                { minAge: 56, maxAge: 60, premium: 132.0 }
            ],
            20000: [
                { minAge: 18, maxAge: 25, premium: 58.0 },
                { minAge: 26, maxAge: 35, premium: 71.0 },
                { minAge: 36, maxAge: 45, premium: 97.0 },
                { minAge: 46, maxAge: 55, premium: 154.0 },
                { minAge: 56, maxAge: 60, premium: 207.5 }
            ],
            40000: [
                { minAge: 18, maxAge: 25, premium: 80.5 },
                { minAge: 26, maxAge: 35, premium: 103.5 },
                { minAge: 36, maxAge: 45, premium: 151.0 },
                { minAge: 46, maxAge: 55, premium: 259.0 },
                { minAge: 56, maxAge: 60, premium: 358.0 }
            ],
            50000: [
                { minAge: 18, maxAge: 25, premium: 91.5 },
                { minAge: 26, maxAge: 35, premium: 119.5 },
                { minAge: 36, maxAge: 45, premium: 179.0 },
                { minAge: 46, maxAge: 55, premium: 311.5 },
                { minAge: 56, maxAge: 60, premium: 429.5 }
            ],
            60000: [
                { minAge: 18, maxAge: 25, premium: 108.0 },
                { minAge: 26, maxAge: 35, premium: 152.0 },
                { minAge: 36, maxAge: 45, premium: 216.0 },
                { minAge: 46, maxAge: 55, premium: 365.0 },
                { minAge: 56, maxAge: 60, premium: 510.5 }
            ],
            80000: [
                { minAge: 18, maxAge: 25, premium: 132.5 },
                { minAge: 26, maxAge: 35, premium: 189.0 },
                { minAge: 36, maxAge: 45, premium: 273.5 },
                { minAge: 46, maxAge: 55, premium: 472.0 },
                { minAge: 56, maxAge: 60, premium: 660.5 }
            ]
        },
        1500: {
            10000: [
                { minAge: 18, maxAge: 25, premium: 47.5 },
                { minAge: 26, maxAge: 35, premium: 56.0 },
                { minAge: 36, maxAge: 45, premium: 72.0 },
                { minAge: 46, maxAge: 55, premium: 108.5 },
                { minAge: 56, maxAge: 60, premium: 143.0 }
            ],
            20000: [
                { minAge: 18, maxAge: 25, premium: 58.5 },
                { minAge: 26, maxAge: 35, premium: 73.0 },
                { minAge: 36, maxAge: 45, premium: 100.5 },
                { minAge: 46, maxAge: 55, premium: 161.0 },
                { minAge: 56, maxAge: 60, premium: 218.5 }
            ],
            40000: [
                { minAge: 18, maxAge: 25, premium: 81.0 },
                { minAge: 26, maxAge: 35, premium: 105.5 },
                { minAge: 36, maxAge: 45, premium: 154.5 },
                { minAge: 46, maxAge: 55, premium: 266.0 },
                { minAge: 56, maxAge: 60, premium: 369.0 }
            ],
            50000: [
                { minAge: 18, maxAge: 25, premium: 92.0 },
                { minAge: 26, maxAge: 35, premium: 121.5 },
                { minAge: 36, maxAge: 45, premium: 182.5 },
                { minAge: 46, maxAge: 55, premium: 318.5 },
                { minAge: 56, maxAge: 60, premium: 440.5 }
            ],
            60000: [
                { minAge: 18, maxAge: 25, premium: 108.5 },
                { minAge: 26, maxAge: 35, premium: 154.0 },
                { minAge: 36, maxAge: 45, premium: 219.5 },
                { minAge: 46, maxAge: 55, premium: 372.0 },
                { minAge: 56, maxAge: 60, premium: 521.5 }
            ],
            80000: [
                { minAge: 18, maxAge: 25, premium: 133.0 },
                { minAge: 26, maxAge: 35, premium: 191.0 },
                { minAge: 36, maxAge: 45, premium: 277.0 },
                { minAge: 46, maxAge: 55, premium: 479.0 },
                { minAge: 56, maxAge: 60, premium: 671.5 }
            ]
        },
        2000: {
            10000: [
                { minAge: 18, maxAge: 25, premium: 48.5 },
                { minAge: 26, maxAge: 35, premium: 57.5 },
                { minAge: 36, maxAge: 45, premium: 75.0 },
                { minAge: 46, maxAge: 55, premium: 114.5 },
                { minAge: 56, maxAge: 60, premium: 154.5 }
            ],
            20000: [
                { minAge: 18, maxAge: 25, premium: 59.5 },
                { minAge: 26, maxAge: 35, premium: 74.5 },
                { minAge: 36, maxAge: 45, premium: 103.5 },
                { minAge: 46, maxAge: 55, premium: 167.0 },
                { minAge: 56, maxAge: 60, premium: 230.0 }
            ],
            40000: [
                { minAge: 18, maxAge: 25, premium: 82.0 },
                { minAge: 26, maxAge: 35, premium: 107.0 },
                { minAge: 36, maxAge: 45, premium: 157.5 },
                { minAge: 46, maxAge: 55, premium: 272.0 },
                { minAge: 56, maxAge: 60, premium: 380.5 }
            ],
            50000: [
                { minAge: 18, maxAge: 25, premium: 93.0 },
                { minAge: 26, maxAge: 35, premium: 123.0 },
                { minAge: 36, maxAge: 45, premium: 185.5 },
                { minAge: 46, maxAge: 55, premium: 324.5 },
                { minAge: 56, maxAge: 60, premium: 452.0 }
            ],
            60000: [
                { minAge: 18, maxAge: 25, premium: 109.5 },
                { minAge: 26, maxAge: 35, premium: 155.5 },
                { minAge: 36, maxAge: 45, premium: 222.5 },
                { minAge: 46, maxAge: 55, premium: 378.0 },
                { minAge: 56, maxAge: 60, premium: 533.0 }
            ],
            80000: [
                { minAge: 18, maxAge: 25, premium: 134.0 },
                { minAge: 26, maxAge: 35, premium: 192.5 },
                { minAge: 36, maxAge: 45, premium: 280.0 },
                { minAge: 46, maxAge: 55, premium: 485.0 },
                { minAge: 56, maxAge: 60, premium: 683.0 }
            ]
        }
    },
    Myself: {
        1000: {
            10000: [
                { minAge: 18, maxAge: 25, premium: 22.0 }, 
                { minAge: 26, maxAge: 35, premium: 34.0 }, 
                { minAge: 36, maxAge: 45, premium: 41.0 }, 
                { minAge: 46, maxAge: 55, premium: 56.5 }, 
                { minAge: 56, maxAge: 60, premium: 75.0 } 
            ],
            20000: [
                { minAge: 18, maxAge: 25, premium: 26.5 },
                { minAge: 26, maxAge: 35, premium: 47.5 },
                { minAge: 36, maxAge: 45, premium: 58.0 },
                { minAge: 46, maxAge: 55, premium: 80.5 },
                { minAge: 56, maxAge: 60, premium: 110.5 }
            ],
            40000: [
                { minAge: 18, maxAge: 25, premium: 39.0 },
                { minAge: 26, maxAge: 35, premium: 83.0 },
                { minAge: 36, maxAge: 45, premium: 101.0 },
                { minAge: 46, maxAge: 55, premium: 129.5 },
                { minAge: 56, maxAge: 60, premium: 181.0 }
            ],
            50000: [
                { minAge: 18, maxAge: 25, premium: 44.0 },
                { minAge: 26, maxAge: 35, premium: 98.0 },
                { minAge: 36, maxAge: 45, premium: 120.0 },
                { minAge: 46, maxAge: 55, premium: 154.0 },
                { minAge: 56, maxAge: 60, premium: 216.0 }
            ],
            60000: [
                { minAge: 18, maxAge: 25, premium: 49.0 },
                { minAge: 26, maxAge: 35, premium: 113.0 },
                { minAge: 36, maxAge: 45, premium: 139.5 },
                { minAge: 46, maxAge: 55, premium: 178.0 },
                { minAge: 56, maxAge: 60, premium: 251.5 }
            ],
            80000: [
                { minAge: 18, maxAge: 25, premium: 59.5 },
                { minAge: 26, maxAge: 35, premium: 144.0 },
                { minAge: 36, maxAge: 45, premium: 176.5 },
                { minAge: 46, maxAge: 55, premium: 226.5 },
                { minAge: 56, maxAge: 60, premium: 320.5 }
            ]
        },
        1500: {
            10000: [
                { minAge: 18, maxAge: 25, premium: 22.5 },
                { minAge: 26, maxAge: 35, premium: 36.0 },
                { minAge: 36, maxAge: 45, premium: 44.5 },
                { minAge: 46, maxAge: 55, premium: 63.5 },
                { minAge: 56, maxAge: 60, premium: 86.0 }
            ],
            20000: [
                { minAge: 18, maxAge: 25, premium: 27.0 },
                { minAge: 26, maxAge: 35, premium: 49.5 },
                { minAge: 36, maxAge: 45, premium: 61.5 },
                { minAge: 46, maxAge: 55, premium: 87.5 },
                { minAge: 56, maxAge: 60, premium: 121.5 }
            ],
            40000: [
                { minAge: 18, maxAge: 25, premium: 39.5 },
                { minAge: 26, maxAge: 35, premium: 85.0 },
                { minAge: 36, maxAge: 45, premium: 104.5 },
                { minAge: 46, maxAge: 55, premium: 136.5 },
                { minAge: 56, maxAge: 60, premium: 192.0 }
            ],
            50000: [
                { minAge: 18, maxAge: 25, premium: 44.5 },
                { minAge: 26, maxAge: 35, premium: 100.0 },
                { minAge: 36, maxAge: 45, premium: 123.5 },
                { minAge: 46, maxAge: 55, premium: 161.0 },
                { minAge: 56, maxAge: 60, premium: 227.0 }
            ],
            60000: [
                { minAge: 18, maxAge: 25, premium: 49.5 },
                { minAge: 26, maxAge: 35, premium: 115.0 },
                { minAge: 36, maxAge: 45, premium: 143.0 },
                { minAge: 46, maxAge: 55, premium: 185.0 },
                { minAge: 56, maxAge: 60, premium: 262.5 }
            ],
            80000: [
                { minAge: 18, maxAge: 25, premium: 60.0 },
                { minAge: 26, maxAge: 35, premium: 146.0 },
                { minAge: 36, maxAge: 45, premium: 180.0 },
                { minAge: 46, maxAge: 55, premium: 233.5 },
                { minAge: 56, maxAge: 60, premium: 331.5 }
            ]
        },
        2000: {
            10000: [
                { minAge: 18, maxAge: 25, premium: 23.5 },
                { minAge: 26, maxAge: 35, premium: 37.5 },
                { minAge: 36, maxAge: 45, premium: 47.5 },
                { minAge: 46, maxAge: 55, premium: 69.5 },
                { minAge: 56, maxAge: 60, premium: 97.5 }
            ],
            20000: [
                { minAge: 18, maxAge: 25, premium: 28.0 },
                { minAge: 26, maxAge: 35, premium: 51.0 },
                { minAge: 36, maxAge: 45, premium: 64.5 },
                { minAge: 46, maxAge: 55, premium: 93.5 },
                { minAge: 56, maxAge: 60, premium: 133.0 }
            ],
            40000: [
                { minAge: 18, maxAge: 25, premium: 40.5 },
                { minAge: 26, maxAge: 35, premium: 86.5 },
                { minAge: 36, maxAge: 45, premium: 107.5 },
                { minAge: 46, maxAge: 55, premium: 142.5 },
                { minAge: 56, maxAge: 60, premium: 203.5 }
            ],
            50000: [
                { minAge: 18, maxAge: 25, premium: 45.5 },
                { minAge: 26, maxAge: 35, premium: 101.5 },
                { minAge: 36, maxAge: 45, premium: 126.5 },
                { minAge: 46, maxAge: 55, premium: 167.0 },
                { minAge: 56, maxAge: 60, premium: 238.5 }
            ],
            60000: [
                { minAge: 18, maxAge: 25, premium: 50.5 },
                { minAge: 26, maxAge: 35, premium: 116.5 },
                { minAge: 36, maxAge: 45, premium: 146.0 },
                { minAge: 46, maxAge: 55, premium: 191.0 },
                { minAge: 56, maxAge: 60, premium: 274.0 }
            ],
            80000: [
                { minAge: 18, maxAge: 25, premium: 61.0 },
                { minAge: 26, maxAge: 35, premium: 147.5 },
                { minAge: 36, maxAge: 45, premium: 183.0 },
                { minAge: 46, maxAge: 55, premium: 239.5 },
                { minAge: 56, maxAge: 60, premium: 343.0 }
            ]
        }
    }
};
export const myselfIncomeStabilizationMock = {
    1000: {
        10000: [
            { minAge: 18, maxAge: 25, premium: 21.0 },
            { minAge: 26, maxAge: 35, premium: 23.5 },
            { minAge: 36, maxAge: 45, premium: 33.0 },
            { minAge: 46, maxAge: 55, premium: 56.0 },
            { minAge: 56, maxAge: 60, premium: 75.0 }
        ],
        20000: [
            { minAge: 18, maxAge: 25, premium: 23.0 },
            { minAge: 26, maxAge: 35, premium: 27.5 },
            { minAge: 36, maxAge: 45, premium: 43.0 },
            { minAge: 46, maxAge: 55, premium: 79.0 },
            { minAge: 56, maxAge: 60, premium: 109.0 }
        ],
        40000: [
            { minAge: 18, maxAge: 25, premium: 27.0 },
            { minAge: 26, maxAge: 35, premium: 35.5 },
            { minAge: 36, maxAge: 45, premium: 63.0 },
            { minAge: 46, maxAge: 55, premium: 127.5 },
            { minAge: 56, maxAge: 60, premium: 178.5 }
        ],
        50000: [
            { minAge: 18, maxAge: 25, premium: 29.5 },
            { minAge: 26, maxAge: 35, premium: 39.0 },
            { minAge: 36, maxAge: 45, premium: 72.5 },
            { minAge: 46, maxAge: 55, premium: 148.5 },
            { minAge: 56, maxAge: 60, premium: 213.0 }
        ],
        60000: [
            { minAge: 18, maxAge: 25, premium: 31.5 },
            { minAge: 26, maxAge: 35, premium: 43.0 },
            { minAge: 36, maxAge: 45, premium: 82.5 },
            { minAge: 46, maxAge: 55, premium: 171.5 },
            { minAge: 56, maxAge: 60, premium: 246.5 }
        ],
        80000: [
            { minAge: 18, maxAge: 25, premium: 35.5 },
            { minAge: 26, maxAge: 35, premium: 51.0 },
            { minAge: 36, maxAge: 45, premium: 102.5 },
            { minAge: 46, maxAge: 55, premium: 217.5 },
            { minAge: 56, maxAge: 60, premium: 316.0 }
        ]
    },
    1500: {
        10000: [
            { minAge: 18, maxAge: 25, premium: 21.5 },
            { minAge: 26, maxAge: 35, premium: 24.5 },
            { minAge: 36, maxAge: 45, premium: 35.5 },
            { minAge: 46, maxAge: 55, premium: 63.5 },
            { minAge: 56, maxAge: 60, premium: 85.5 }
        ],
        20000: [
            { minAge: 18, maxAge: 25, premium: 23.5 },
            { minAge: 26, maxAge: 35, premium: 28.5 },
            { minAge: 36, maxAge: 45, premium: 45.0 },
            { minAge: 46, maxAge: 55, premium: 85.5 },
            { minAge: 56, maxAge: 60, premium: 119.5 }
        ],
        40000: [
            { minAge: 18, maxAge: 25, premium: 27.5 },
            { minAge: 26, maxAge: 35, premium: 36.5 },
            { minAge: 36, maxAge: 45, premium: 65.5 },
            { minAge: 46, maxAge: 55, premium: 132.0 },
            { minAge: 56, maxAge: 60, premium: 188.0 }
        ],
        50000: [
            { minAge: 18, maxAge: 25, premium: 30.0 },
            { minAge: 26, maxAge: 35, premium: 40.0 },
            { minAge: 36, maxAge: 45, premium: 65.0 },
            { minAge: 46, maxAge: 55, premium: 154.0 },
            { minAge: 56, maxAge: 60, premium: 213.5 }
        ],
        60000: [
            { minAge: 18, maxAge: 25, premium: 32.0 },
            { minAge: 26, maxAge: 35, premium: 44.0 },
            { minAge: 36, maxAge: 45, premium: 85.0 },
            { minAge: 46, maxAge: 55, premium: 178.0 },
            { minAge: 56, maxAge: 60, premium: 257.0 }
        ],
        80000: [
            { minAge: 18, maxAge: 25, premium: 36.0 },
            { minAge: 26, maxAge: 35, premium: 52.0 },
            { minAge: 36, maxAge: 45, premium: 105.0 },
            { minAge: 46, maxAge: 55, premium: 224.0 },
            { minAge: 56, maxAge: 60, premium: 326.5 }
        ]
    },
    2000: {
        10000: [
            { minAge: 18, maxAge: 25, premium: 22.5 },
            { minAge: 26, maxAge: 35, premium: 25.5 },
            { minAge: 36, maxAge: 45, premium: 38.5 },
            { minAge: 46, maxAge: 55, premium: 68.5 },
            { minAge: 56, maxAge: 60, premium: 97.0 }
        ],
        20000: [
            { minAge: 18, maxAge: 25, premium: 24.5 },
            { minAge: 26, maxAge: 35, premium: 29.5 },
            { minAge: 36, maxAge: 45, premium: 48.5 },
            { minAge: 46, maxAge: 55, premium: 91.5 },
            { minAge: 56, maxAge: 60, premium: 131.0 }
        ],
        40000: [
            { minAge: 18, maxAge: 25, premium: 28.5 },
            { minAge: 26, maxAge: 35, premium: 37.5 },
            { minAge: 36, maxAge: 45, premium: 68.5 },
            { minAge: 46, maxAge: 55, premium: 128.0 },
            { minAge: 56, maxAge: 60, premium: 200.5 }
        ],
        50000: [
            { minAge: 18, maxAge: 25, premium: 31.0 },
            { minAge: 26, maxAge: 35, premium: 41.0 },
            { minAge: 36, maxAge: 45, premium: 78.0 },
            { minAge: 46, maxAge: 55, premium: 161.0 },
            { minAge: 56, maxAge: 60, premium: 225.0 }
        ],
        60000: [
            { minAge: 18, maxAge: 25, premium: 33.0 },
            { minAge: 26, maxAge: 35, premium: 45.0 },
            { minAge: 36, maxAge: 45, premium: 88.0 },
            { minAge: 46, maxAge: 55, premium: 184.0 },
            { minAge: 56, maxAge: 60, premium: 266.5 }
        ],
        80000: [
            { minAge: 18, maxAge: 25, premium: 37.0 },
            { minAge: 26, maxAge: 35, premium: 53.0 },
            { minAge: 36, maxAge: 45, premium: 108.0 },
            { minAge: 46, maxAge: 55, premium: 230.0 },
            { minAge: 56, maxAge: 60, premium: 318.0 }
        ]
    }
};
export const paidUpMock = [
    {
        minAge: 18,
        maxAge: 25,
        charge: 7.5
    },
    {
        minAge: 26,
        maxAge: 35,
        charge: 15
    },
    {
        minAge: 36,
        maxAge: 50,
        charge: 35
    }
];

// [
//     {
//         minAge: 18,
//         maxAge: 20,
//         premium: 0,
//     },
//     {
//         minAge: 21,
//         maxAge: 25,
//         premium: 0,
//     },
//     {
//         minAge: 26,
//         maxAge: 30,
//         premium: 0,
//     },
//     {
//         minAge: 31,
//         maxAge: 35,
//         premium: 0,
//     },
//     {
//         minAge: 36,
//         maxAge: 40,
//         premium: 0,
//     },
//     {
//         minAge: 41,
//         maxAge: 45,
//         premium: 0,
//     },
//     {
//         minAge: 46,
//         maxAge: 50,
//         premium: 0,
//     },
//     {
//         minAge: 51,
//         maxAge: 55,
//         premium: 0,
//     },
//     {
//         minAge: 56,
//         maxAge: 60,
//         premium: 0,
//     },
//     {
//         minAge: 61,
//         maxAge: 65,
//         premium: 0,
//     },
//     {
//         minAge: 66,
//         maxAge: 70,
//         premium: 0,
//     },
// ],
